module.exports = __webpack_public_path__ + "img/masterlock-wake-up.a805d723.png";